import { render, staticRenderFns } from "./VenuePinMap.vue?vue&type=template&id=6a0b8cfd"
import script from "./VenuePinMap.vue?vue&type=script&lang=js"
export * from "./VenuePinMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports